import { Backdrop, Box, Button, Checkbox, CircularProgress, FormControlLabel, Stack, TextField, Typography } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import { API } from "../conf";
import { Context } from "../App";


export default function SendRecuForm(props) {
    const {updateConnect} = useContext(Context)
    const [to_donat, setTodonat] = useState(false)
    const [to_inputmails, setToinput] = useState(false)
    const [mails, setmails]=useState('')
    const [load, setLoad] = useState(false)

    function handleSubmit(event) {
        event.preventDefault();
        setLoad(true)
        const emails = mails.replace(/\s/g, '').split(';').filter(mail=> mail!=='')
        const regex = /^[\w-]+(\.[\w-]+)*@([\w-]+\.)+[a-zA-Z]{2,7}$/;
        //alerte si aucune adresse mail ou bad format
        if (!to_donat&&emails.length<=0) {
            setLoad(false)
            return alert('Aucun destinataire spécifié!')
        }
        for(let i = 0; i < emails.length; i++) {
            if (!regex.test(emails[i])) {
                setLoad(false)
                return alert("Le format d'une ou plusieurs des adresses mail que vous avez spécifiées est incorrecte.")
            }
        }
        fetch(API.concat(`/dons/${JSON.stringify(props.dons)}/send_recu`), {method:'POST', headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + sessionStorage.getItem('token')
            }, body: JSON.stringify({mails: emails, to_donat: to_donat})
        }).then(async response=>{
            const token = response.headers.get('x-auth-token')
            if(response.status === 401) {
                sessionStorage.clear()
                updateConnect(false)
            }else {
                if (token && token !== sessionStorage.getItem('token') && token !== '') {
                    sessionStorage.setItem('token', response.headers.get('x-auth-token'))
                }
                if (response.status===200) {
                    props.snackbar("Reçu(s) envoyé(s) avec succès")
                    props.close()
                } else {
                    const json = response.json()
                    const msg = to_donat ?
                     `Une erreur est survenue lors de l'envoie de reçu à ${json.length} donateur(s).\nIl se peut qu'aucune adresse mail n'est été trouvée pour ce(s) donateur(s)`
                    :`Une erreur est survenue lors de l'envoie de mail.`
                    props.snackbar(msg)
                    props.close()
                }
                setLoad(false)
            }
        })
    }

    return(
        <Box component={'form'} onSubmit={handleSubmit} display='flex' flexDirection='column' sx={{padding:'20px'}}>
            <Typography variant="h4" align="center">Partager le(s) reçu(s)</Typography>
            
            <FormControlLabel label={`Envoyer ${props.ismany ? 'tout' : ''} par e-mail à :` } control={<Checkbox checked={to_inputmails} onClick={()=>setToinput(old=> props.donators.length<=1 ? !old: true)}/>}/>
            {to_inputmails&&<TextField fullWidth margin="normal" placeholder="Entrez les adresses e-mail séparées par des ;(point-virgule)" type="email" multiline rows={2} value={mails} onChange={(e)=>setmails(e.target.value)}/>}            
            <FormControlLabel label={`Envoyer ${props.ismany ?'individuellement à chaque donateur ayant':"au donateur s'il a"} spécifié une adresse e-mail`} control={<Checkbox checked={to_donat} onClick={()=>setTodonat(old=> props.donators.length<=1 ? !old: true)}/>}/>
            
            <embed src={props.recu} width='100%' height='400px' type="application/pdf" />
            <Button type="submit" variant="contained" 
            disabled={!to_donat&&((to_inputmails&&mails.replace(/\s/g, '').split(';').filter(mail=> mail!=='').length<=0)||!to_inputmails)} 
            style={{alignSelf:'end', marginTop:'10px'}}>Envoyer</Button>
            <Backdrop open={load}><CircularProgress/></Backdrop>
        </Box>
    )
    
}